import React from 'react';
import { Typography } from '@kareo/design-system';
import { formatISODateShort } from 'shared-assets/facesheet-ui/utils/patientHelper';
import { Grid, Box } from '@material-ui/core';
import CachedDataWarning from '../Error/CachedDataWarning';
import { CACHED_DATA_MESSAGE } from '../../../service/patient/types';
var ProblemsContent = function (_a) {
    var hasNoKnownProblems = _a.hasNoKnownProblems, problemsData = _a.problemsData, cachedDate = _a.cachedDate;
    return (React.createElement(Grid, { container: true, spacing: 1 },
        cachedDate && (React.createElement(Box, { width: "100%", mb: 1.3 },
            React.createElement(CachedDataWarning, { messageType: CACHED_DATA_MESSAGE.WITH_DATE, lastCachedDate: cachedDate, displayBorder: true, addSuffix: true }))),
        hasNoKnownProblems ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "body1", component: "div" }, "No Known Problems"))) : !problemsData.content || problemsData.content.length == 0 ? (React.createElement(Grid, { item: true, xs: 12 },
            React.createElement(Typography, { variant: "body1", component: "div" }, "(None documented)"))) : (problemsData.content.map(function (item, index) { return (React.createElement(Grid, { item: true, xs: 12, key: index },
            React.createElement(Typography, { variant: "body1", component: "div" },
                item.problem,
                item.acuteness && item.acuteness !== 'NA'
                    ? " (" + item.acuteness.toLowerCase() + ")"
                    : undefined,
                item.startDate
                    ? " (" + formatISODateShort(item.startDate) + ")"
                    : undefined,
                item.comments ? " - " + item.comments : undefined))); }))));
};
export default ProblemsContent;
